export default "__VITE_ASSET__b572f35d__"